import POSScreen from './POSScreen.jsx';
import { ShiftGate } from '../../shared/ShiftGate.jsx';

export default {
  path: '/pos',
  element: <ShiftGate what="البيع"><POSScreen /></ShiftGate>,
  protected: true,
  // Needs EITHER sub-permission. anyPermission gates the sidebar item AND the
  // page; the component still does per-department checks (pos.cafeteria.sell /
  // pos.toys.sell) so a user with only one department sees only that tab.
  permission: null,
  anyPermission: ['pos.cafeteria.sell', 'pos.toys.sell'],
  standalone: false,
  sidebar: { label: 'نقاط البيع', icon: 'pos', group: 'sales', order: 50 }
};
